

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';

import { moveUpMotion } from 'mwc/core/animation';

import { MwcMNComponent } from './base';
import { MwcMessageData } from './typings';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  selector: 'mwc-message',
  exportAs: 'mwcMessage',
  preserveWhitespaces: false,
  animations: [moveUpMotion],
  template: `
    <div
      class="mwc-message-notice"
      [@moveUpMotion]="instance.state"
      (@moveUpMotion.done)="animationStateChanged.next($event)"
      (mouseenter)="onEnter()"
      (mouseleave)="onLeave()"
    >
      <div class="mwc-message-notice-content">
        <div class="mwc-message-custom-content" [ngClass]="'mwc-message-' + instance.type">
          <ng-container [ngSwitch]="instance.type">
            <span *ngSwitchCase="'success'" mwc-icon mwcType="check-circle"></span>
            <span *ngSwitchCase="'info'" mwc-icon mwcType="info-circle"></span>
            <span *ngSwitchCase="'warning'" mwc-icon mwcType="exclamation-circle"></span>
            <span *ngSwitchCase="'error'" mwc-icon mwcType="close-circle"></span>
            <span *ngSwitchCase="'loading'" mwc-icon mwcType="loading"></span>
          </ng-container>
          <ng-container *mwcStringTemplateOutlet="instance.content">
            <span [innerHTML]="instance.content"></span>
          </ng-container>
        </div>
      </div>
    </div>
  `
})
export class MwcMessageComponent extends MwcMNComponent implements OnInit, OnDestroy {
  @Input() override instance!: Required<MwcMessageData>;
  @Output() override readonly destroyed = new EventEmitter<{ id: string; userAction: boolean }>();

  constructor(cdr: ChangeDetectorRef) {
    super(cdr);
  }
}
